import { render, staticRenderFns } from "./PaymentPendingBoleto.vue?vue&type=template&id=5f4da42a"
import script from "./PaymentPendingBoleto.vue?vue&type=script&lang=js"
export * from "./PaymentPendingBoleto.vue?vue&type=script&lang=js"
import style0 from "./PaymentPendingBoleto.vue?vue&type=style&index=0&id=5f4da42a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports